// extracted by mini-css-extract-plugin
export default {"holdings-title":"AccountReportRoot_holdings-title__VsqhS","report-root":"AccountReportRoot_report-root__fyCIY"};